import { defineStore } from "pinia";
import { ref } from "vue";

export const useAppStore = defineStore("app", () => {
  const refreshKey = ref(0);

  const triggerRefresh = () => {
    refreshKey.value++;
  };

  return {
    refreshKey,
    triggerRefresh,
  };
});
